import gql from "graphql-tag";

export const TABLA_OBJETIVOS_ADMIN_FRAGMENT = gql`
  fragment tablaObjetivosAdminFragment on TablaObjetivosAdmin {
    codigoDistribuidor
    nombreDistribuidor
    mes
    codObjetivo
    nombreObjetivo
    nivel
    comercialHesa
    codAgrupacion
    agrupacion
    codTipoObjetivo
    tipoObjetivo
    codTipoPeriodo
    fechaPeriodo
    cantidadObjetivo
    cantidadActual
    cumplimiento
    incentivoTeorico
    incentivoReal
    incentivo
    estado
  }
`;

export const TABLA_OBJETIVOS_ADMIN = gql`
  query tablaObjetivosAdmin ($fechaDesde: String, $fechaHasta: String, $codDistribuidor: Long) {
    TablaObjetivosAdmin: tablaObjetivosAdmin(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, codDistribuidor: $codDistribuidor) {
      ...tablaObjetivosAdminFragment
    }
  }
  ${TABLA_OBJETIVOS_ADMIN_FRAGMENT}
`;
